import LoginLayout from "../../shared-components/login-layout/login-layout";
import EmailVerificationForm from "./email-verification-form/email-verification-form";

const EmailVerification = () => {
  return (
    <LoginLayout
      title="Verify Email"
      subTitle="Your email is not verified yet. If the email below is not correct you can add the correct email."
      showBackButton={true}
    >
      <EmailVerificationForm />
    </LoginLayout>
  );
};

export default EmailVerification;
